import React, { useState, useEffect, useReducer, useRef, useContext } from "react";
import clsx from "clsx";
import { API, graphqlOperation, Storage, Auth } from "aws-amplify";
import NumberFormat from "react-number-format";
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Backdrop from "@material-ui/core/Backdrop";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from "@material-ui/lab/Alert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import logger from "../logger";
import { generateTimestampId, generateSlug } from "../functions";
import { updateProduct } from "../graphql/mutations";
import { AppContext } from "../views/App";
import FileUploader from "./FileUploader";
import TabPanel from "./TabPanel";
import FaqList from "./FaqList";
import { PRODUCT_MAX_IMAGE_COUNT } from "./ProductoCreate";
import { MobileContext } from "../views/app/Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  },
  backButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  control: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  switch: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: 0,
    marginRight: 0
  },
  button: {
    marginBottom: theme.spacing(5)
  },
  featuresButtons: {
    marginTop: "auto",
    textAlign: "right",
    paddingTop: theme.spacing(2)
  },
  tabbar: {
    top: "56px",
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      top: "48px"
    },
    [theme.breakpoints.up("sm")]: {
      top: "64px"
    },
    backgroundColor: theme.palette.primary.light
  },
  tabpanel: {
    padding: theme.spacing(4, 0),
    width: "100%"
  },
  section: {
    marginBottom: theme.spacing(4)
  },
  sectionTitle: {
    marginBottom: theme.spacing(2)
  },
  featurecolumn: {
    height: "auto",
    [theme.breakpoints.up("sm")]: {
      height: "40vh"
    },
    overflow: "auto"
  },
  featurelist: {
    backgroundColor: "#efefef"
  },
  featuredetails: {
    padding: theme.spacing(2)
  },
  featuretitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  featureoptionlist: {
    marginTop: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "400px"
  },
  featureitemtext: {
    backgroundColor: "#ffffff"
  },
  verticalAlign: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }
}));

const tabs = {
  general: { value: 0, label: "General" },
  avanzado: { value: 1, label: "Avanzado" },
  faq: { value: 2, label: "Preguntas Frecuentes" }
};

const initialState = {
  name: "",
  price: "",
  priceOnSale: "",
  category: null,
  medias: [],
  descripcion: "",
  withDelivery: true,
  status: true,
  featured: false,
  features: [],
  stock: false,
  stockFeatures: [],
  aditionalFeatures: {
    status: false,
    depth: "",
    height: "",
    sku: "",
    weight: "",
    width: ""
  }
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case "name":
    case "description":
    case "price":
    case "priceOnSale":
    case "category":
    case "withDelivery":
    case "status":
    case "featured":
    case "features":
    case "stock":
    case "stockFeatures":
    case "aditionalFeatures":
      return { ...state, [type]: payload };
    case "add_medias":
      return { ...state, medias: [...state.medias, payload] };
    case "edit_medias":
      return { ...state, medias: payload };
    case "remove_medias":
      return {
        ...state,
        medias: [...state.medias.filter(m => m !== payload)]
      };
    case "load":
      return { ...state, ...payload };
    case "reset":
      return { ...initialState };
    default:
      return { ...state };
  }
};

const Caracteristica = ({
  parent = null,
  type,
  value,
  selected = false,
  disabled = false,
  divider = false,
  onClick = () => {},
  onChange,
  onDelete
}) => {
  const classes = useStyles();
  const [edit, setEdit] = useState(false);
  const labelRef = useRef(null);

  const agregar = () => {
    const newLabel = labelRef.current.value.trim();

    if (newLabel !== "") {
      onChange({
        parent,
        value: generateTimestampId(),
        label: newLabel
      });

      labelRef.current.value = "";
    }
  };

  const guardar = () => {
    const updatedLabel = labelRef.current.value.trim();

    if (updatedLabel !== "") {
      onChange({ parent, ...value, label: updatedLabel });

      setEdit(false);
    }
  };

  const eliminar = () => {
    onDelete({ parent, ...value });
  };

  if (value) {
    if (edit) {
      return (
        <ListItem divider={divider} selected={selected}>
          <ListItemText
            primary={
              <TextField
                fullWidth
                autoFocus
                size="small"
                className={classes.featureitemtext}
                placeholder={`Nombre de ${type}`}
                disabled={disabled}
                defaultValue={value.label}
                inputProps={{
                  ref: labelRef,
                  maxLength: 25
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" disabled={disabled} onClick={guardar}>
                        <SaveIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            }
          />
        </ListItem>
      );
    } else {
      return (
        <ListItem
          button
          divider={divider}
          disabled={disabled}
          selected={selected}
          onClick={() => onClick(value)}
        >
          <ListItemText primary={value.label} />
          {Boolean(parent) ? (
            <ListItemSecondaryAction>
              <IconButton edge="end" disabled={disabled} onClick={() => setEdit(true)}>
                <EditIcon />
              </IconButton>

              <IconButton className="ml-2" edge="end" disabled={disabled} onClick={eliminar}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          ) : (
            <ListItemSecondaryAction onClick={() => onClick(value)}>
              <ChevronRightIcon />
            </ListItemSecondaryAction>
          )}
        </ListItem>
      );
    }
  } else {
    return (
      <ListItem divider={divider} selected={selected}>
        <ListItemText
          primary={
            <TextField
              fullWidth
              size="small"
              className={classes.featureitemtext}
              placeholder={`Agregar ${type}`}
              disabled={disabled}
              inputProps={{
                ref: labelRef,
                maxLength: 25
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" disabled={disabled} onClick={agregar}>
                      <AddIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          }
        />
      </ListItem>
    );
  }
};

const Caracteristicas = ({ features, selected, onSelect, onChange }) => {
  const classes = useStyles();
  const [editTitle, setEditTitle] = useState(false);
  const labelRef = useRef(null);

  const newCaracteristica = caracteristica => {
    const { parent, value, label } = caracteristica;
    const payload = [...features];

    if (parent) {
      const options = [...parent.options, { value, label }];

      for (let i = 0; i < payload.length; i++) {
        if (payload[i].value === parent.value) {
          payload[i].options = options;
          break;
        }
      }
    } else {
      payload.push({ value, label, options: [] });
      onSelect(payload[payload.length - 1]);
    }

    onChange(payload);
  };

  const updateCaracteristica = caracteristica => {
    const { parent, value, label } = caracteristica;
    const payload = [...features];

    if (parent) {
      const options = [...parent.options];

      for (let i = 0; i < options.length; i++) {
        if (options[i].value === value) {
          options[i].label = label;
          break;
        }
      }

      for (let i = 0; i < payload.length; i++) {
        if (payload[i].value === parent.value) {
          payload[i].options = options;
          break;
        }
      }
    } else {
      for (let i = 0; i < payload.length; i++) {
        if (payload[i].value === value) {
          payload[i].label = label;
          break;
        }
      }
    }

    onChange(payload);
  };

  const deleteCaracteristica = caracteristica => {
    const { parent, value } = caracteristica;

    let payload = null;

    if (parent) {
      const options = [...parent.options.filter(o => o.value !== value)];
      payload = [...features];

      for (let i = 0; i < payload.length; i++) {
        if (payload[i].value === parent.value) {
          payload[i].options = options;
          break;
        }
      }
    } else {
      payload = [...features.filter(f => f.value !== value)];

      if (selected.value === value) {
        onSelect(null);
      }
    }

    if (payload) {
      onChange(payload);
    }
  };

  const guardarTitulo = () => {
    const label = labelRef.current.value.trim();

    if (label !== "") {
      updateCaracteristica({ ...selected, label });

      setEditTitle(false);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={4}>
        <Paper square className={clsx(classes.featurelist, classes.featurecolumn)}>
          <List disablePadding>
            {features.map((feature, i) => (
              <Caracteristica
                divider
                key={`feature-${i}`}
                type="característica"
                value={feature}
                selected={selected && selected.value === feature.value}
                onClick={() => onSelect(feature)}
                onChange={updateCaracteristica}
                onDelete={deleteCaracteristica}
              />
            ))}
            <Caracteristica type="característica" onChange={newCaracteristica} />
          </List>
        </Paper>
      </Grid>

      <Grid item xs={12} sm={8}>
        <Paper square className={classes.featurecolumn}>
          {selected && (
            <Grid container className={classes.featuredetails}>
              <Grid item xs={12} className={classes.featuretitle}>
                {editTitle ? (
                  <TextField
                    fullWidth
                    autoFocus
                    size="small"
                    className={classes.featureitemtext}
                    placeholder={`Nombre de característica`}
                    defaultValue={selected.label}
                    inputProps={{
                      ref: labelRef,
                      maxLength: 25
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end" onClick={guardarTitulo}>
                            <SaveIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                ) : (
                  <div className={classes.featuretitle}>
                    <Typography component="span" variant="h5">
                      {selected.label}
                    </Typography>

                    <IconButton className="ml-3" edge="end" onClick={() => setEditTitle(true)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}

                <IconButton
                  className="ml-2"
                  edge="end"
                  onClick={() => deleteCaracteristica(selected)}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>

              <Grid item xs={12}>
                <List className={classes.featureoptionlist}>
                  {selected.options.map((option, i) => (
                    <Caracteristica
                      divider
                      key={`option-${i}`}
                      parent={selected}
                      type="opción"
                      value={option}
                      onChange={updateCaracteristica}
                      onDelete={deleteCaracteristica}
                    />
                  ))}
                  <Caracteristica parent={selected} type="opción" onChange={newCaracteristica} />
                </List>
              </Grid>
            </Grid>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

const CaracteristicasAdicionales = ({ aditionalFeatures, onChange }) => {
  const setAditionalFeatures = ({ target }) => {
    onChange({
      type: "aditionalFeatures",
      payload: {
        ...aditionalFeatures,
        status: target.checked
      }
    });
  };

  const aditionalFeaturesField = ({ label, value, type, scale }) => {
    return (
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth component="fieldset">
          <FormLabel component="legend">{label}</FormLabel>
          <NumberFormat
            thousandSeparator="."
            decimalSeparator=","
            customInput={TextField}
            allowNegative={false}
            size="small"
            variant="standard"
            value={value}
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">{scale}</InputAdornment>
            }}
            onValueChange={({ value }) =>
              onChange({
                type: "aditionalFeatures",
                payload: {
                  ...aditionalFeatures,
                  [type]: value
                }
              })
            }
          />
        </FormControl>
      </Grid>
    );
  };

  const aditionalFeaturesForm = () => {
    return (
      <>
        <Grid container item xs={12} spacing={4} className="mb-2">
          {aditionalFeaturesField({
            label: "Peso",
            value: aditionalFeatures.weight,
            type: "weight",
            scale: "Kg."
          })}

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth component="fieldset">
              <FormLabel component="legend">SKU</FormLabel>
              <TextField
                size="small"
                variant="standard"
                value={aditionalFeatures.sku}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={({ target }) => {
                  onChange({
                    type: "aditionalFeatures",
                    payload: {
                      ...aditionalFeatures,
                      sku: target.value
                    }
                  });
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" component="p">
              Datos de volumen
            </Typography>
          </Grid>

          {aditionalFeaturesField({
            label: "Alto",
            value: aditionalFeatures.height,
            type: "height",
            scale: "Cm."
          })}

          {aditionalFeaturesField({
            label: "Ancho",
            value: aditionalFeatures.width,
            type: "width",
            scale: "Cm."
          })}

          {aditionalFeaturesField({
            label: "Largo",
            value: aditionalFeatures.depth,
            type: "depth",
            scale: "Cm."
          })}
        </Grid>
      </>
    );
  };

  return (
    <Paper square className="p-3">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={aditionalFeatures.status}
                  name="aditionalFeaturesStatus"
                  onChange={setAditionalFeatures}
                />
              }
              label="Habilitar"
            />
          </FormGroup>
        </Grid>

        {aditionalFeatures.status && aditionalFeaturesForm()}
      </Grid>
    </Paper>
  );
};

const Stock = ({ features, stock, stockFeatures, onChange }) => {
  const [addCombination, setAddCombination] = useState(false);
  const [newFeatures, setNewFeatures] = useState({});
  const [quantity, setQuantity] = useState(null);
  const classes = useStyles();

  const setStock = ({ target }) => onChange({ type: "stock", payload: target.checked });

  const setStockFeatures = () => {
    if (Object.keys(newFeatures).length === features.length && quantity) {
      onChange({
        type: "stockFeatures",
        payload: [...stockFeatures, { ...newFeatures, quantity }]
      });

      setAddCombination(false);
      setNewFeatures({});
      setQuantity(null);

      return true;
    }

    return false;
  };

  const removeStockFeature = index => {
    onChange(stockFeatures.splice(index, 1));
  };

  const StockFeaturesList = () => {
    return (
      <>
        <Grid item xs={12} className="d-flex flex-wrap" style={{ marginRight: "40px" }}>
          {features &&
            features.map(feature => (
              <Typography
                key={`stock-feature-head-${feature.value}`}
                variant="h6"
                className={classes.verticalAlign}
              >
                {feature.label}
              </Typography>
            ))}
          <Typography variant="h6" className={classes.verticalAlign}>
            Cantidad
          </Typography>
        </Grid>

        {stockFeatures &&
          stockFeatures.map((stockFeature, index) => (
            <Grid item xs={12} key={`stock-feature-list-${index}`} className="d-flex flex-wrap">
              {features &&
                features.map(feature => (
                  <>
                    {stockFeature[feature.value] ? (
                      <Typography
                        key={`stock-feature-list-${feature.value}`}
                        className={classes.verticalAlign}
                        variant="body1"
                      >
                        {stockFeature[feature.value].options.label}
                      </Typography>
                    ) : (
                      <Typography
                        key={`stock-feature-list-none`}
                        className={classes.verticalAlign}
                        variant="body1"
                      >
                        --
                      </Typography>
                    )}
                  </>
                ))}
              <Typography variant="body1" className={classes.verticalAlign}>
                <NumberFormat
                  displayType={"text"}
                  thousandSeparator="."
                  decimalSeparator=","
                  value={stockFeature.quantity}
                />
              </Typography>

              <IconButton className="ml-2" edge="end" onClick={() => removeStockFeature(index)}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          ))}
      </>
    );
  };

  const addCombinationForm = () => {
    return (
      <>
        {features && features.length > 0 && (
          <Grid item xs={12} sm={6}>
            {features.map(feature => (
              <Grid item xs={12} key={`stock-feature-${feature.value}`}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">{feature.label}</FormLabel>
                  <RadioGroup
                    row
                    aria-label={feature.label}
                    name={feature.value}
                    value={newFeatures[feature.value]}
                    onChange={({ target }) =>
                      setNewFeatures({
                        ...newFeatures,
                        [target.name]: {
                          ...feature,
                          options: feature.options.find(option => option.value === target.value)
                        }
                      })
                    }
                  >
                    {feature.options.map(option => (
                      <FormControlLabel
                        key={`stock-feature-option-${option.value}`}
                        control={<Radio />}
                        label={option.label}
                        value={option.value}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
            ))}
          </Grid>
        )}

        <Grid container item xs={12} sm={6}>
          <Grid item xs={12}>
            <FormControl fullWidth component="fieldset">
              <FormLabel component="legend">Cantidad *</FormLabel>
              <NumberFormat
                thousandSeparator="."
                decimalSeparator=","
                customInput={TextField}
                allowNegative={false}
                placeholder="Ej: 100"
                size="small"
                variant="standard"
                value={quantity}
                onValueChange={({ value }) => setQuantity(value)}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} className={classes.featuresButtons}>
            <Button onClick={() => setAddCombination(false)}>Cancelar</Button>
            <Button color="primary" onClick={() => setStockFeatures()}>
              Guardar
            </Button>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <Paper square className="p-3">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormGroup row>
            <FormControlLabel
              control={<Checkbox checked={stock} name="stock" onChange={setStock} />}
              label="Habilitar stock"
            />
          </FormGroup>
        </Grid>

        {stock && (
          <>
            {(stockFeatures || []).length > 0 && <StockFeaturesList />}

            {features.length === 0 && (stockFeatures || []).length === 0 && addCombinationForm()}

            {features.length > 0 && (
              <>
                {addCombination ? (
                  addCombinationForm()
                ) : (
                  <Grid item xs={12}>
                    <Button startIcon={<AddIcon />} onClick={() => setAddCombination(true)}>
                      Agregar combinación
                    </Button>
                  </Grid>
                )}
              </>
            )}
          </>
        )}
      </Grid>
    </Paper>
  );
};

const ProductoDetails = ({ producto, onClose, onChange }) => {
  const classes = useStyles();
  const { store } = useContext(AppContext);
  const { mobile } = useContext(MobileContext);
  const [tab, setTab] = useState(tabs.general.value);
  const [enviando, setEnviando] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [selectedFeature, setSelectedFeature] = useState(null);

  useEffect(() => {
    if (store && producto) {
      const clone = JSON.parse(JSON.stringify(producto));

      const category = store.body.categories.filter(c => c.value === clone.body.category)[0];
      const features = clone.body.features || [];
      const stock = clone.body.stock || false;
      const stockFeatures = clone.body.stockFeatures || [];
      const featured = clone.body.featured || false;

      dispatch({
        type: "load",
        payload: { ...clone, ...clone.body, category, features, stock, stockFeatures, featured }
      });

      setTab(tabs.general.value);
      setSelectedFeature(null);
    }
  }, [store, producto]);

  const close = () => {
    dispatch({
      type: "reset"
    });
    onClose();
  };

  const validarCaracteristicas = () => {
    for (let i = 0; i < state.features.length; i++) {
      if (state.features[i].options.length === 0) {
        return false;
      }
    }

    return true;
  };

  const validarBasico = () => {
    return state.name !== "" && state.price !== "" && state.category && state.medias.length > 0;
  };

  const validar = () => {
    return validarBasico() && validarCaracteristicas();
  };

  const getSalePercentage = () => {
    const price = parseInt(state.price);
    const priceOnSale = parseInt(state.priceOnSale);

    if (price > priceOnSale) {
      const percentage = 100 - (priceOnSale * 100) / price;

      if (Number.isInteger(percentage)) {
        return percentage;
      } else {
        return `~${Math.round(percentage)}`;
      }
    }

    return null;
  };

  const guardar = async () => {
    setEnviando(true);
    let vars = null;

    try {
      const credentials = await Auth.currentCredentials();
      const apiMedias = [];

      const config = {
        bucket: process.env.REACT_APP_CF_BUCKET,
        region: process.env.REACT_APP_REGION,
        level: "public",
        identityId: credentials.identityId
      };

      const ctx = new Date().toISOString().replace(/[TZ:\-.]/g, "");

      for (let i = 0; i < state.medias.length; i++) {
        const media = state.medias[i];

        if (media.url) {
          media.name = `${producto.id}-${ctx}-${i}${media.extension}`;
          media.key = store.id + "/" + producto.id + "/" + media.name;

          // Save in S3
          await Storage.put(media.key, media.blob, {
            ...config,
            contentType: media.type
          });
        }

        apiMedias.push({
          key: media.key,
          name: media.name,
          extension: media.extension,
          size: media.size,
          type: media.type,
          bucket: process.env.REACT_APP_CF_BUCKET
        });
      }

      const {
        id,
        name,
        description,
        withDelivery,
        category,
        features,
        aditionalFeatures,
        stock,
        stockFeatures,
        priceOnSale,
        featured
      } = state;

      const updatedAt = new Date().toISOString();
      const status = Number(state.status);

      const body = {
        ...producto.body,
        description,
        category: category.value,
        withDelivery,
        features,
        sale: {
          percentage: getSalePercentage(),
          value: priceOnSale
        },
        featured,
        aditionalFeatures,
        stock,
        stockFeatures
      };

      vars = {
        input: {
          id,
          name,
          price: state.price,
          slug: generateSlug(name),
          status,
          updatedAt,
          body: JSON.stringify(body),
          medias: apiMedias
        }
      };

      await API.graphql(graphqlOperation(updateProduct, vars));

      const init = {
        body: {
          product: id,
          store: store.id,
          name,
          data: JSON.stringify(updateProduct),
          status
        }
      };

      await API.post(process.env.REACT_APP_HUB_API, "/analytics/products", init);

      onChange();
      onClose();
    } catch (err) {
      logger("ProductoDetails.guardar.error", { err, vars });
    }

    setEnviando(false);
  };

  const addMedia = media => {
    dispatch({
      type: "add_medias",
      payload: media
    });
  };

  const editMedia = (currentMedia, newMedia) => {
    const medias = state.medias.map((m, i) => {
      if (m === currentMedia) {
        return newMedia;
      }

      return m;
    });

    dispatch({
      type: "edit_medias",
      payload: medias
    });
  };

  const removeMedia = media => {
    dispatch({
      type: "remove_medias",
      payload: media
    });
  };

  const updateFeatures = updated => {
    dispatch({ type: "features", payload: updated });
  };

  const Switches = () => {
    return (
      <>
        <FormControlLabel
          className={clsx(classes.control, classes.switch)}
          label="Producto disponible para la venta"
          labelPlacement="start"
          control={
            <Switch
              color="primary"
              disabled={enviando}
              checked={Boolean(state.status)}
              onChange={({ target }) =>
                dispatch({
                  type: "status",
                  payload: Number(target.checked)
                })
              }
            />
          }
        />

        <FormControlLabel
          className={clsx(classes.control, classes.switch)}
          label="Producto destacado"
          labelPlacement="start"
          control={
            <Switch
              color="primary"
              disabled={enviando}
              checked={Boolean(state.featured)}
              onChange={({ target }) =>
                dispatch({
                  type: "featured",
                  payload: Number(target.checked)
                })
              }
            />
          }
        />

        <FormControlLabel
          className={clsx(classes.control, classes.switch)}
          label="Producto físico"
          labelPlacement="start"
          control={
            <Switch
              color="primary"
              disabled={enviando}
              checked={state.withDelivery}
              onChange={({ target }) =>
                dispatch({
                  type: "withDelivery",
                  payload: target.checked
                })
              }
            />
          }
        />
      </>
    );
  };

  const renderBasico = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            className={classes.control}
            disabled={enviando}
            label="Nombre *"
            placeholder="Ej: Polerón azul"
            size="small"
            variant="standard"
            value={state.name}
            onChange={({ target }) => dispatch({ type: "name", payload: target.value })}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            fullWidth
            multiline
            rows={6}
            className={classes.control}
            label="Descripción"
            placeholder="Ej: Polerón de buzo ondero"
            disabled={enviando}
            size="small"
            variant="standard"
            value={state.description}
            onChange={({ target }) => dispatch({ type: "description", payload: target.value })}
            InputLabelProps={{
              shrink: true
            }}
          />

          <NumberFormat
            fullWidth
            thousandSeparator="."
            decimalSeparator=","
            prefix="$"
            customInput={TextField}
            className={classes.control}
            label="Precio *"
            placeholder="Ej: $25.000"
            disabled={enviando}
            size="small"
            variant="standard"
            value={state.price}
            onValueChange={({ value }) =>
              dispatch({
                type: "price",
                payload: value
              })
            }
            inputProps={{
              maxLength: 8
            }}
            InputLabelProps={{
              shrink: true
            }}
          />

          <NumberFormat
            fullWidth
            thousandSeparator="."
            decimalSeparator=","
            prefix="$"
            customInput={TextField}
            className={classes.control}
            label="Precio en descuento"
            placeholder="Ej: $20.000"
            disabled={enviando}
            size="small"
            variant="standard"
            value={state.priceOnSale}
            onValueChange={({ value }) =>
              dispatch({
                type: "priceOnSale",
                payload: value
              })
            }
            inputProps={{
              maxLength: 8
            }}
            InputLabelProps={{
              shrink: true
            }}
          />

          {store.body.categories.length > 1 && (
            <Autocomplete
              className={classes.control}
              options={store.body.categories}
              getOptionLabel={c => c.label}
              value={state.category}
              onChange={(_, value) => dispatch({ type: "category", payload: value })}
              renderInput={params => (
                <TextField
                  {...params}
                  fullWidth
                  variant="standard"
                  size="small"
                  label="Categoría *"
                  disabled={enviando}
                />
              )}
            />
          )}

          <Hidden smDown>
            <Switches />
          </Hidden>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FileUploader
            parent="product-view"
            className="product-media-container"
            data={state.medias}
            maxFiles={PRODUCT_MAX_IMAGE_COUNT}
            onAdd={addMedia}
            onEdit={editMedia}
            onRemove={removeMedia}
          />
        </Grid>

        <Hidden mdUp>
          <Grid item xs={12}>
            <Switches />
          </Grid>
        </Hidden>

        <Grid item xs={12}>
          <Container maxWidth="xs">
            <Button
              fullWidth
              className={classes.button}
              variant="contained"
              color="secondary"
              disabled={enviando || !validar()}
              onClick={guardar}
            >
              {enviando ? "Enviando" : "Aceptar"}
            </Button>
          </Container>
        </Grid>
      </Grid>
    );
  };

  const renderAvanzado = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.section}>
          <Typography className={classes.sectionTitle} variant="h5">
            Características
          </Typography>

          {!validarCaracteristicas() && (
            <Alert severity="warning" className="mb-3">
              <strong>Atención.</strong> Debes completar las opciones de tus nuevas características.
            </Alert>
          )}

          <Caracteristicas
            features={state.features}
            selected={selectedFeature}
            onSelect={feature => setSelectedFeature(feature)}
            onChange={updateFeatures}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sectionTitle} variant="h5">
            Características adicionales
          </Typography>

          <CaracteristicasAdicionales
            aditionalFeatures={state.aditionalFeatures}
            onChange={({ type, payload }) => dispatch({ type, payload })}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sectionTitle} variant="h5">
            Stock
          </Typography>

          <Stock
            features={state.features}
            stock={state.stock}
            stockFeatures={state.stockFeatures}
            onChange={({ type, payload }) => dispatch({ type, payload })}
          />
        </Grid>

        <Grid item xs={12}>
          <Container maxWidth="xs">
            <Button
              fullWidth
              className={classes.button}
              variant="contained"
              color="secondary"
              disabled={enviando || !validar()}
              onClick={guardar}
            >
              {enviando ? "Enviando" : "Aceptar"}
            </Button>
          </Container>
        </Grid>
      </Grid>
    );
  };

  const renderFAQ = () => {
    return <FaqList storeID={store.id} productID={producto.id} mobile={mobile} />;
  };

  if (!producto) return null;

  return (
    <Drawer
      className={classes.drawer}
      open={Boolean(producto)}
      anchor="right"
      classes={{
        paper: classes.drawerPaper
      }}
      onClose={close}
    >
      <Backdrop className="backdrop" open={enviando}>
        <CircularProgress />
      </Backdrop>

      <AppBar position="sticky">
        <Toolbar>
          <IconButton className={classes.backButton} edge="start" color="inherit" onClick={onClose}>
            <ArrowBackIcon />
          </IconButton>

          <Typography className={classes.title} variant="h6">
            Editar Producto
          </Typography>
        </Toolbar>
      </AppBar>

      <AppBar className={classes.tabbar} position="sticky" elevation={0}>
        <Tabs
          variant={mobile ? "fullWidth" : "standard"}
          centered={!mobile}
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
        >
          <Tab label={tabs.general.label} />
          <Tab label={tabs.avanzado.label} />
          <Tab label={tabs.faq.label} />
        </Tabs>
      </AppBar>

      <Container maxWidth="md">
        <TabPanel className={classes.tabpanel} index={tabs.general.value} tab={tab}>
          {renderBasico()}
        </TabPanel>

        <TabPanel className={classes.tabpanel} index={tabs.avanzado.value} tab={tab}>
          {renderAvanzado()}
        </TabPanel>

        <TabPanel className={classes.tabpanel} index={tabs.faq.value} tab={tab}>
          {renderFAQ()}
        </TabPanel>
      </Container>
    </Drawer>
  );
};

export default ProductoDetails;
